import { AxiosRequestConfig } from 'axios';
import { APIService } from './APIService';

/**
 * Aliases to the APIService.createEndpoint methods
 * @param endpoint
 * @param config
 */
export const createEndpoint = (endpoint: string, config: AxiosRequestConfig = {}) =>
    APIService.getInstance().createEndpoint(endpoint, config);

/**
 * Aliases to the APIService.createHTTP methods
 * @param path
 * @param config
 */
export const createHTTP = (path: string, config: AxiosRequestConfig = {}) =>
    APIService.getInstance().createHTTP(path, config);
